/* eslint-disable react/no-string-refs */
import React from 'react';

// Make hatTarget 'ref="hatTarget"'
// Add '.fill' to all body elements
// Add '.fill--face' to nose

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

export default class Heads extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="194.39067" cy="225.5538" r="0" />
				<path className="fill fill--dark ear ear--right" d="M268.11105,241.4136
					c-10.19409,12.28036-28.41325,13.97163-40.69362,3.77756c-12.28036-10.19409-13.97163-28.41324-3.77756-40.6936
					c20.32719-24.48729,66.76442-27.36226,60.11342-12.85396C279.64874,200.59717,278.30511,229.13324,268.11105,241.4136z" />
				<path className="fill fill--dark ear ear--left" d="M132.80215,241.4136
					c10.19409,12.28036,28.41324,13.97163,40.6936,3.77756c12.28038-10.19409,13.97165-28.41324,3.77756-40.6936
					c-20.32719-24.48729-66.7644-27.36226-60.1134-12.85396C121.26447,200.59717,122.60808,229.13324,132.80215,241.4136z" />
				<path className="fill" d="M198.46716,208.66602c48.53682,0,64.33514,38.47952,64.33514,74.6619
					c0,21.03772-28.80383,54.99689-64.33514,54.99689c-44.23743,2.13107-62.49545-33.4259-62.49545-53.71524
					C135.97171,235.59955,149.93033,208.66602,198.46716,208.66602z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Pig/Heads.js